import { Card, CloseButton } from 'react-bootstrap'

const VideoPlayerSketchfab = ({videolink,setVideoPlayer}) => {
    return(
        <>
            <Card id="overlays" className=' border-0 rounded-0 p-1 m-1'>
            <CloseButton  onClick={() => setVideoPlayer(null)} className='align-self-end bg-white border-0 btn-white btn-sm rounded-circle p-1 m-1 p-md-2' />
                <Card.Body>
                    <iframe
                        className="sketchfab-inside-videoPlayer"
                        src={`https://www.youtube.com/embed/${videolink}&autoplay=1&showinfo=0&controls=1`}
                        title="YouTube video player"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                    ></iframe>
                </Card.Body>
            </Card>
        </>
    )
}

export default VideoPlayerSketchfab;